'use strict';

var processInclude = require('base/util');
var productTileKeyboardNav = require('./product/productTileKeyboardNav');

$(document).ready(function () {
    processInclude(require('./product/quickView'));
    processInclude(require('wishList/product/wishlistHeart'));
    var keyboardNav = productTileKeyboardNav();
    keyboardNav.init();
});
